import React from "react"
import Link from "next/link"
import { useRouter } from "next/router"

interface IconLinkProps {
  icon: React.ReactNode
  url: string
  isExternal: boolean
}

export const IconLink: React.FC<IconLinkProps> = ({ icon, url, isExternal }) => {
  const router = useRouter()

  const handleClick = (e: React.MouseEvent) => {
    if (!isExternal) {
      e.preventDefault()
      void router.push(url)
    }
  }

  if (isExternal) {
    return (
      <a href={url} target="_blank" rel="noopener noreferrer">
        {icon}
      </a>
    )
  }

  return (
    <Link href={url} passHref>
      <a onClick={handleClick}>{icon}</a>
    </Link>
  )
}
